"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Icon_1 = require("../Icon/Icon");
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputEl = null;
        _this.onChangeHandler = function (event) {
            var _a = _this.props, onChange = _a.onChange, indeterminate = _a.indeterminate;
            if (indeterminate) {
                onChange && onChange(false);
            }
            else {
                var state = event.target.checked;
                onChange && onChange(state);
            }
        };
        return _this;
    }
    Checkbox.prototype.componentDidMount = function () {
        this.inputEl.indeterminate = this.props.indeterminate;
    };
    Checkbox.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.indeterminate !== this.props.indeterminate) {
            this.inputEl.indeterminate = this.props.indeterminate;
        }
    };
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, checked = _a.checked, className = _a.className, style = _a.style, inline = _a.inline, disabled = _a.disabled, hideCheckbox = _a.hideCheckbox, block = _a.block, indeterminate = _a.indeterminate, children = _a.children;
        var classes = classNames('form-group__checkbox', {
            'form-group__checkbox--checked': checked,
            'form-group__checkbox--inline': inline,
            'form-group__checkbox--disabled': disabled,
            'form-group__checkbox--hidden': hideCheckbox,
            'form-group__checkbox--indeterminate': indeterminate,
            'form-group__checkbox-block': block
        }, className);
        var childIsString = typeof children === 'string';
        return (React.createElement("label", { className: classes, style: style },
            React.createElement("input", { type: "checkbox", checked: checked, onChange: this.onChangeHandler, disabled: disabled, ref: function (el) { return (_this.inputEl = el); } }),
            React.createElement("span", { className: "form-group__checkbox-indicator" },
                !indeterminate && (React.createElement(Icon_1.default, { icon: 'check', color: "white", style: { opacity: checked ? '1' : '0' } })),
                indeterminate && React.createElement(Icon_1.default, { icon: 'minus', color: "white" })),
            block ? (React.createElement("div", { className: "form-group__checkbox-block__content" }, children)) : (React.createElement("span", { className: "form-group__checkbox__content" }, children))));
    };
    Checkbox.defaultProps = {
        checked: false,
        indeterminate: false
    };
    return Checkbox;
}(React.Component));
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Checkbox/Checkbox.js
// module id = 273
// module chunks = 0